export default function Container(theme) {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: "0 !important",
        },
      },
    },
  };
}
